import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { CREATE_LOST_FOUND_ITEM } from '../graphql/lost-found-queries';
import LostFoundForm from '../components/LostFoundForm';
import { toast } from 'react-hot-toast';

const CreateLostFound = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [createLostFoundItem] = useMutation(CREATE_LOST_FOUND_ITEM, {
    refetchQueries: ['GetLostFoundItems'],
  });

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    try {
      const { data } = await createLostFoundItem({
        variables: {
          input: {
            propertyId: formData.propertyId,
            reservationId: formData.reservationId,
            category: formData.category || 'LOST_ITEM_FOUND',
            description: formData.description,
            photos: formData.photos,
            returnOfficeInstructions: formData.returnOfficeInstructions,
          }
        }
      });

      toast.success('Lost and found item created successfully!');
      navigate('/dashboard/lost-found');
    } catch (error) {
      console.error('Error creating lost and found item:', error);
      toast.error(error.message || 'Failed to create lost and found item');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Add Lost and Found Item</h1>
        <p className="mt-1 text-sm text-gray-500">
          Fill in the details about the lost item below.
        </p>
      </div>

      <div className="bg-white shadow-sm rounded-lg p-6">
        <LostFoundForm onSubmit={handleSubmit} isLoading={isSubmitting} />
      </div>
    </div>
  );
};

export default CreateLostFound; 
